import { Component, Input, Output, EventEmitter } from '@angular/core';

import { DropdownOption } from '../select.component';

@Component({
  selector: 'app-select-option',
  templateUrl: './select-option.component.html',
  styleUrls: ['./select-option.component.scss'],
  standalone: false,
})
export class SelectOptionComponent {
  @Input() public label?: string;
  @Input() public value?: string | number;
  @Input() public disabled?: boolean;
  @Output() public selected = new EventEmitter<DropdownOption>();

  public onSelect(): void {
    this.selected.emit({ label: this.label ?? '', value: this.value ?? '' });
  }
}
